export default __webpack_public_path__ + "static/media/travelPlans.114169c4.svg";